import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "../services/utils/HttpUtils";
import { ASSUMPTION_QUERY } from "../graphql/queries_assumptions";
import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";

type Props = {
    scenarioID: string,
    instance: IPublicClientApplication
    accounts: AccountInfo[]
};


const useBaseLineAssumption = ({ scenarioID, instance, accounts }: Props) => {

    const { data: baseLineAssumption, isSuccess: isBaseLineAssumptionSuccess } = useQuery(["getBaselineAssumption"], {
        queryFn: () => {
            return apiRequest(
                {
                    query: ASSUMPTION_QUERY,
                    variables: {
                        inScenarioID: scenarioID,
                        inDefaultValue: 0
                    },
                    instance: instance,
                    accounts: accounts
                })
        }
    })

    return ({ baseLineAssumption, isBaseLineAssumptionSuccess });
}

export default useBaseLineAssumption;